





























import { Component, Vue } from "vue-property-decorator";
import { app } from "./models/Application";
import { config } from "@/config";

@Component({})
export default class extends Vue {
    private version = config.version;
    private static timer = null;
    private static timerLoginCheckInterval = 15 * 60 * 1000;

    constructor() {
        super();
    }

    public mounted() {
        (this.$root as any).$confirm = (this.$refs.confirm as any).open;
    }

    private async checkLogin() {
        // if (this.$route && this.$route.name === "login") {
        //     return;
        // }
        // try {
        //     const result = await api.isLoginValid();
        // } catch (e) {
        //     this.$router.push({name: "login"});
        // }
    }
}
